import Skeleton, { SkeletonTheme } from "react-loading-skeleton"
import React from 'react';

export default function HeaderShimmer(){
    return(
        <>
            <div className="flex justify-between items-center mt-8 sm:flex-row flex-col">
                <div className='sm:w-auto w-full'>
                        
                    <p className='w-[70px]'>
                        <SkeletonTheme baseColor="#f0f0f0" highlightColor="#e0e0e0" className="pt-4 min-w-[70px]">
                            <Skeleton count={1} className='h-[30px] rounded-[42px] w-[70px]'/>
                        </SkeletonTheme>
                    </p>
                    <p className='w-[300px]' >
                        <SkeletonTheme baseColor="#f0f0f0" highlightColor="#e0e0e0" className="pt-4 min-w-[70px]">
                            <Skeleton count={1} className='h-[30px] rounded-[42px] w-[300px]'/>
                        </SkeletonTheme>
                    </p>
                        
                </div>
                <div className='flex'>
                    <p className='mr-3'>
                        <SkeletonTheme baseColor="#f0f0f0" highlightColor="#e0e0e0" className="pt-4">
                            <Skeleton count={1} className='h-[40px] min-w-[130px] pt-4 mr-2 ' />
                        </SkeletonTheme>        
                    </p>  
                    <p className=''>
                        <SkeletonTheme baseColor="#f0f0f0" highlightColor="#e0e0e0" className="pt-4">
                            <Skeleton count={1} className='h-[40px] min-w-[130px] pt-4 ' />
                        </SkeletonTheme>        
                    </p>  
                </div>
        
                {/* <!-- box content --> */}
            </div>
            <div className="flex ss:flex-nowrap flex-wrap mt-6">
                <div className="ss:w-1/3 w-full min-h-[99px] lg:px-10 px-5 pt-3 ss:mb-0 mb-2.5 rounded-[20px] bg-[#DDD1D5]">
                    <p className="text-[12px] leading-normal animate-pulse h-5 bg-[#dbd9d9f3]"></p>
                    <p className='md:w-[30%] w-full animate-pulse h-10 bg-[#dbd9d9f3] mt-2'></p>
                </div>
                <div className=" ss:w-1/3 w-full min-h-[99px] px-5 lg:px-10 pt-3 ss:mx-5 ss:mb-0 mb-2.5 
                    rounded-[20px] bg-[#B8D5DB]">
                    <p className="text-[12px] leading-normal animate-pulse h-5 bg-[#dbd9d9f3]"></p>
                    <p className='md:w-[30%] w-full animate-pulse h-10 bg-[#dbd9d9f3] mt-2'></p>
                </div>
                <div className="ss:w-1/3 w-full min-h-[99px] px-5 lg:px-10 pt-3 rounded-[20px] ss:mb-0 mb-2.5 bg-[#ECD6C7]">
                    <p className="text-[12px] leading-normal animate-pulse h-5 bg-[#dbd9d9f3]"></p>
                    <p className='md:w-[30%] w-full animate-pulse h-10 bg-[#dbd9d9f3] mt-2'></p>
                </div>
            </div>
        </>
    )
}